/* External */
import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { List } from 'immutable';

/* Components */
import Season from './Season';
import ScrollIntoViewIfFocused from '../ScrollIntoViewIfFocused';

/* Utils */
import { noOp } from '../../utils/functions';
import ScrollView, { ScrollPosition } from '../ScrollView';
import { Direction } from '../../utils/spatialNavigation';

/* Styles */
import './SeasonSelector.scss';

function SeasonSelector({
  onSeasonSelect,
  seasonsList,
  selectedSeasonNumber,
  focusRestorable,
  onScrolledChange,
}) {
  const handleFocused = useCallback((componentLayout, { seasonNumber }) => {
    onScrolledChange(true);
    onSeasonSelect(seasonNumber);
  }, [onSeasonSelect, onScrolledChange]);

  const handleSeasonArrowPress = useCallback(
    (direction, { index }) => !(direction === Direction.DOWN && index === seasonsList.size),
    [seasonsList.size],
  );

  return (
    <ScrollView
      propagateEventOnReachTop
      className="dtv-html5-c-season-selector"
    >
      <ul className="dtv-html5-c-season-selector__seasons-container" role="menu">
        {seasonsList.map(({ seasonNumber }, index) => {
          const isSelected = seasonNumber === selectedSeasonNumber;
          return (
            <ScrollIntoViewIfFocused
              key={seasonNumber}
              className="dtv-html5-c-season-selector__lane-card"
              position={ScrollPosition.CENTER}
            >
              <Season
                index={index}
                seasonNumber={seasonNumber}
                isSelected={isSelected}
                onBecameFocused={handleFocused}
                onSelect={onSeasonSelect}
                focusRestorable={focusRestorable && isSelected}
                onArrowPress={handleSeasonArrowPress}
              />
            </ScrollIntoViewIfFocused>
          );
        })}
      </ul>
    </ScrollView>
  );
}

SeasonSelector.defaultProps = {
  onSeasonSelect: noOp,
  onScrolledChange: noOp,
  seasonsList: [],
  selectedSeasonNumber: undefined,
  focusRestorable: false,
};

SeasonSelector.propTypes = {
  onSeasonSelect: PropTypes.func,
  onScrolledChange: PropTypes.func,
  seasonsList: PropTypes.instanceOf(List),
  selectedSeasonNumber: PropTypes.number,
  focusRestorable: PropTypes.bool,
};

export default memo(withFocusable()(memo(SeasonSelector)));
